module.exports = {"title":"Sign up","registerButton":"Register","password":"Password","alreadyRegistered":"Already registered?","loginAction":"Log in","meta":"Sign up"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/signup.json
// module id = YmMU
// module chunks = 1